<template>
  <form v-if="value">
    <string-form-field
      label="Titolo"
      :value="value.title"
      :disabled="disabled"
      :error="findError('title')"
      @input="propertyChanged('title', $event)"
    />

    <string-form-field
      label="Descrizione"
      :value="value.description"
      :disabled="disabled"
      :error="findError('description')"
      @input="propertyChanged('description', $event)"
    />
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
